import { Scene } from 'phaser'
import Button from './../components/Button'
import Score from './../components/Score'
import TokenBag from './../components/TokenBag'
import Dialog from './../components/Dialog'
import capturer from '@/game/assets/token/capturer.png'
import message from '@/game/assets/message.png'
import classement from '@/game/assets/classement.png'
import regle from '@/game/assets/regle.png'
import croix from '@/game/assets/croix.png'

const DEFAULT_WIDTH = 1200;
const DEFAULT_HEIGHT = 900;
const screenWidth = window.innerWidth;
const screenHeight = window.innerHeight;
const scale = Math.min(screenWidth/DEFAULT_WIDTH,screenHeight/DEFAULT_HEIGHT);
export default class PlayScene extends Scene {

  constructor () {
    super({ key: 'PlayScene' })
    this.board = null;
    /*this.boardHitAreas = []
    this.hitAreasData = []*/
    this.zoomedIn = false;


    //this.debugGraphics;
  }

  preload(){
    /*this.load.scenePlugin({
      key: 'rexuiplugin',
      url: 'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexuiplugin.min.js',
      sceneKey: 'rexUI'
    }); */
  }

  create () {
    this.boardHitAreas = []
    this.hitAreasData = []
    console.log(screenWidth);
    console.log(screenHeight);
    console.log(scale);
    this.cameras.main.setZoom(scale);
    this.cameras.main.centerOn(0,0);
    //this.cameras.main.setBounds(-1024, -1024, 1024, 1024);
    //this.cameras.main.setZoom(scale);
    //this.game.stage.backgroundColor = '#16a085';
    var t = this
    ///////////this.board = this.add.image(0, 0, 'board');
    console.log("distance");
    console.log(this);
    console.log(-(screenWidth/scale)/2 + (860/scale)/2);
    this.board = this.add.image((-screenWidth/scale)/2 + (958)/2 + 20, 0, 'board');//967
    //this.scoreboard = this.add.image(550, 120, 'scoreboard');
    this.scoreboard = this.add.image((-screenWidth/scale)/2 + (967) + 440, 120, 'scoreboard');//position
    //this.jetons = this.add.image(300, 0, 'jetons');
    this.jetons = this.add.image((-screenWidth/scale)/2 + (967) + 185, 0, 'jetons');//position
    this.board.displayHeight = 860;
    this.board.scaleX = this.board.scaleY;
    this.jetons.displayHeight = 820;
    this.jetons.scaleX = this.jetons.scaleY;
    this.scoreboard.scaleX = this.jetons.scaleY;
    this.scoreboard.scaleY = this.jetons.scaleY;
    console.log(this.jetons);
    //this.board.setAlpha(0.15);
    ////this.board.setDisplaySize(967, 860);
    this.board.setInteractive();
    //this.scorePosition = {x: 610,y: 140};
    this.scorePosition = {x: (-screenWidth/scale)/2 + (967) + 500,y: 140};//position
    console.log("scale");
    console.log(scale);
    const divconseil = document.createElement('div');
    divconseil.style = 'color:#DAB71C; width: '+this.scoreboard.displayWidth+'px; height: auto; font: 50px "Manga";text-align:center;';
    divconseil.innerHTML = "<div>A toi de jouer&nbsp!</div>";
    //italien
    //divconseil.innerHTML = "<div>È il tuo turno di giocare&nbsp!</div>";
    this.containerconseil = this.add.container(0, 0);
    //this.elementconseil = this.add.dom(550, -250, divconseil);
    this.elementconseil = this.add.dom((-screenWidth/scale)/2 + (967) + 440, -250, divconseil);//position
    this.elementconseil.scaleX = this.jetons.scaleY;
    this.elementconseil.scaleY = this.jetons.scaleY;
    //const rect = this.add.rectangle(0, 0, 16, 16, 0xff00ff);
    this.containerconseil.add(this.elementconseil);
    const div = document.createElement('div');
    div.style = 'width:'+screenWidth/scale+'px;height:'+screenHeight/scale+'px;';
    //div.innerHTML = "<div>Pas la bonne zone ! Essaye encore<img src='"+capturer+"'></div>";
    div.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.2);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:577px;height:404px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+message+"\");color:#2D453D; font: 40px \"Inter\"; font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;'>Pas la bonne zone ! Essaye encore !<div id='messageOk' style='font-family:Jumbo;background-color:#32443d;color:white;width:200px;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;'>Ok</div></div></div></div>";
    //italien
    //div.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.2);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:577px;height:404px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+message+"\");color:#2D453D; font: 40px \"Inter\"; font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;'>Non è la zona giusta ! Riprova !<div id='messageOk' style='font-family:Jumbo;background-color:#32443d;color:white;width:200px;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;'>Ok</div></div></div></div>";
    console.log("div");
    //console.log(capturer);
    
    this.container = this.add.container(0, 0);
    this.element = this.add.dom(0, 0, div);
    //const rect = this.add.rectangle(0, 0, 16, 16, 0xff00ff);
    this.container.add(this.element);
    this.container.setVisible(false);
    console.log("this.container");
    console.log(this.container);

    this.divTablecontainer = this.add.container(0, 0);
    this.divTablecontainer.setVisible(false);
    const divnomequipe = document.createElement('div');
    divnomequipe.style = 'width:'+screenWidth/scale+'px;height:'+screenHeight/scale+'px;';
    divnomequipe.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.2);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:930px;height:691px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+classement+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;position:relative;'><div id='textenom' style='font-family: Inter;color: #FDE8CF;font-size: 50px;/* margin-left: 260px; */letter-spacing: 1px;margin-bottom: 20px;'>NOM ÉQUIPE : </div><input type='text' id='nomequipe' name='nomequipe' style='padding:0 30px;border-radius: 50px;border: 0;line-height: 90px;width: 500px;font-size: 60px;color: #36433e;font-family: Inter;background-color: #f7e9d5;'><div id='okname' style='font-size:30px;font-family:Jumbo;background-color:#9A2323;color:white;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;padding: 0 20px;'>Ok</div><div id='showTable' style='width:80%;'></div><img id='croix' style='position: absolute;right: -60px;top: 0;cursor:pointer;' src='"+croix+"'></div></div></div>";
    //italien
    //divnomequipe.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.2);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:930px;height:691px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+classement+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;position:relative;'><div id='textenom' style='font-family: Inter;color: #FDE8CF;font-size: 50px;/* margin-left: 260px; */letter-spacing: 1px;margin-bottom: 20px;'>NOME SQUADRA : </div><input type='text' id='nomequipe' name='nomequipe' style='padding:0 30px;border-radius: 50px;border: 0;line-height: 90px;width: 500px;font-size: 60px;color: #36433e;font-family: Inter;background-color: #f7e9d5;'><div id='okname' style='font-size:30px;font-family:Jumbo;background-color:#9A2323;color:white;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;padding: 0 20px;'>Ok</div><div id='showTable' style='width:80%;'></div><img id='croix' style='position: absolute;right: -60px;top: 0;cursor:pointer;' src='"+croix+"'></div></div></div>";
    var elementnomequipe = this.add.dom(0, 0, divnomequipe);
    this.divTablecontainer.add(elementnomequipe);

    const divmanageZone = document.createElement('div');
    divmanageZone.style = 'width:'+screenWidth/scale+'px;height:'+screenHeight/scale+'px;';
    divmanageZone.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.2);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:577px;height:404px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+message+"\");color:#2D453D; font: 40px \"Inter\"; font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;'>Attention bonne zone mais choix bloquant pour les autres jetons !<div id='messageZoneOk' style='font-family:Jumbo;background-color:#32443d;color:white;width:200px;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;'>Ok</div></div></div></div>";
    //italien
    //divmanageZone.innerHTML = "<div style='background-color: rgba(0, 0, 0, 0.2);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:577px;height:404px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+message+"\");color:#2D453D; font: 40px \"Inter\"; font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;'>Fai attenzione, buona area ma blocca la scelta per gli altri gettoni !<div id='messageZoneOk' style='font-family:Jumbo;background-color:#32443d;color:white;width:200px;border-radius:50px;margin-top:20px;line-height: 80px;height: 80px;letter-spacing: 10px;cursor:pointer;'>Ok</div></div></div></div>";
    this.divmanageZonecontainer = this.add.container(0, 0);
    this.divmanageZoneelement = this.add.dom(0, 0, divmanageZone);
    this.divmanageZonecontainer.add(this.divmanageZoneelement);
    this.divmanageZonecontainer.setVisible(false);

    this.divQuizzcontainer = this.add.container(0, 0);
    this.divQuizzcontainer.setVisible(false);

    this.divResultcontainer = this.add.container(0, 0);
    this.divResultcontainer.setVisible(false);

    /*console.log("scene this");
    console.log(this.cameras.main.getBounds());
    console.log(this.cameras);*/
    /*this.button = this.add.image(0, 0, 'abeille')
    this.button.setInteractive();
    this.button.on('pointerdown', function () {
      document.getElementById("containermenu").style.display="flex";
    }, this);
    document.getElementById('containermenu').onclick = function(){
      document.getElementById("containermenu").style.display="none";
    }*/
    //this.param = this.add.image(650, -390, 'param');
    this.param = this.add.image((-screenWidth/scale)/2 + (967) + 560, -390, 'param');//position
    this.param.setInteractive({
      useHandCursor: true
  });
    //this.credit = this.add.image((-screenWidth/scale)/2 + (967) + 480, -390, 'param');
    //this.param.setVisible(false);
    var a = new TokenBag(this, 1);
    this.score = new Score(this,screenHeight,scale);
    this.scoreLabel.text = 0;
    this.scorex = 0;
    //this.scorey = (screenHeight/scale)/2 - 50;
    this.scorey = this.cameras.main.worldView.bottom -50;
    console.log("this.scoreLabel")
    console.log(this.scoreLabel)
    console.log("camera");
    console.log(this.cameras.main.getBounds());
    var t = this;
    this.input.on("pointermove", function (p) {
      console.log(a.drag);
      var cam = this.cameras.main;
      if (!p.isDown) return;
      console.log("a.drag");
      console.log(a.drag);
      if (!a.drag){
        if (Math.abs(p.x - p.prevPosition.x) > 5){
          cam.scrollX -= (p.x - p.prevPosition.x) / cam.zoom;
        }
        if (Math.abs(p.y - p.prevPosition.y) > 5){
          cam.scrollY -= (p.y - p.prevPosition.y) / cam.zoom;
        }
        console.log(this.cameras.main);
        /*if (this.iszoom == 0){
          this.scoreLabel.x = this.scorex + cam.scrollX + this.cameras.main.midPoint.x;
          this.scoreLabel.y = this.scorey + cam.scrollY +this.cameras.main.midPoint.y;
        }
        else {
          this.scoreLabel.x = this.scorex * scale + cam.scrollX + this.cameras.main.midPoint.x;
          this.scoreLabel.y = this.scorey * scale + cam.scrollY +  this.cameras.main.midPoint.y;
        }*/
        //t.getRelativePositionToCanvas(t.scoreLabel,cam);
        /*let pos = t.getRelativePositionToCanvas(t.scoreLabel,cam);
        this.scoreLabel.x = pos.x;
        this.scoreLabel.y = pos.y*/
      }
      //t.getRelativePositionToCanvas(t.divRegle,t.cameras.main);
    });
    var lastTime = 0;
    this.iszoom = 0;
    this.container.setInteractive(new Phaser.Geom.Rectangle(-450, -200, 900, 400), Phaser.Geom.Rectangle.Contains);
    document.getElementById('messageOk').onclick = function(){
      console.log("DANSGETELEMENTBYID");
      t.container.setVisible(false)
    }
    document.getElementById('messageZoneOk').onclick = function(){
      console.log("DANSGETELEMENTBYID");
      t.divmanageZonecontainer.setVisible(false)
    }
    this.container.on("pointerdown", (p)=>{
      console.log("dans container");
      /*if (this.container.visible && !this.isQuizz){
        this.container.setVisible(false)
        return
      }*/
    });
    this.input.on("pointerdown", (p)=>{
      /*if (this.container.visible && !this.isQuizz){
        this.container.setVisible(false)
        return
      }*/
      
      var clickDelay = this.time.now - lastTime;
      lastTime = this.time.now;
      if(clickDelay < 350) {
        console.log("We're double clicked!");
        console.log(p);
        console.log(p.y);
        if (this.iszoom == 0){
          this.cameras.main.zoomTo(scale+0.3,1000);
          this.cameras.main.pan(p.worldX,p.worldY,1000);
          this.iszoom=1;
          /*setTimeout(() => {
            this.scoreLabel.x = this.scorex * scale + this.cameras.main.midPoint.x;
            this.scoreLabel.y = this.scorey * scale + this.cameras.main.midPoint.y;
        }, 1000)*/
          /*let pos = t.getRelativePositionToCanvas(t.scoreLabel,this.cameras.main);
          console.log(this.cameras.main);
          t.scoreLabel.x = t.scoreLabel.x + this.cameras.main.midPoint.x;
          t.scoreLabel.y = t.scoreLabel.y + this.cameras.main.midPoint.y;*/
        }
        else{
          this.cameras.main.zoomTo(scale,1000);
          this.cameras.main.pan(p.worldX,p.worldY,1000);
          this.iszoom=0;
          /*setTimeout(() => {
            this.scoreLabel.x = this.scorex + this.cameras.main.midPoint.x;
            this.scoreLabel.y = this.scorey + this.cameras.main.midPoint.y;
        }, 1000)*/
          /*let pos = t.getRelativePositionToCanvas(t.scoreLabel,this.cameras.main);
          t.scoreLabel.x = t.scoreLabel.x + this.cameras.main.midPoint.x;
          t.scoreLabel.y = t.scoreLabel.y + this.cameras.main.midPoint.y;*/
        }
        console.log("camera");
        console.log(this.cameras.main);      
      }
  });
    //this.background = this.add.image(0, 0, 'board').setOrigin(0).setScrollFactor(0, 1);
    //this.background = this.add.tileSprite(0, 0, screenWidth, screenHeight, "board").setOrigin(0).setScrollFactor(0, 1);
    //var a = new TokenBag(this, 1)
    
    /*var b = new Dialog(this)
    b.dialog.setVisible(false)*/

    //init 
    /*const settingsButton = new Button(this, 100, 100, '#000', 'Tred', 'Tgreen', 'Settings', () => {
      b.dialog.setVisible(!b.dialog.visible)
      // t.cameras.main.shake(200, 0.02);
      // overlay_text.visible = !overlay_text.visible;
    });*/

    //var cardGroup = this.add.group();

    /*this.board.on('pointerdown', function () {
      var cam = this.cameras.main;
          cam.pan(400, 500, 300, 'Power2');
          cam.zoomTo(1.5, 300);
    }, this);
    this.board.on('pointerup', function() {
      var cam = this.cameras.main;
      cam.pan(640, 480, 300, 'Power2');
      cam.zoomTo(1, 300);
    }, this)*/

    // this.board.on('pointerdown', function(){
    //   t.tweens.add({
    //     targets: t.board,
    //     scaleX: t.zoomedIn ? 1 : 1.6,
    //     scaleY: t.zoomedIn ? 1 : 1.6,
    //     x: t.zoomedIn ? 380 : 690,
    //     y: t.zoomedIn ? 500 : 480,
    //     duration: 700, 
    //     ease: 'Expo.easeOut',
    //     onComplete: function(){
    //       t.zoomedIn = !t.zoomedIn
    //     }
    //   });
    // })



    //bordel

    /*cardGroup.createMultiple({ key: 'card', repeat: 2 });

    let ci = 0;
    cardGroup.children.iterate(child =>
    {
        child.x = -200;
        child.y = 200;
        child.depth = 9 - ci;
        ci++;

        child.setInteractive();
        child.setData('hasChangedTexture', false)

        child.on('pointerdown', function(){
          var chain = t.tweens.chain({
            targets: child,
            tweens: [
              {
                scaleX: 0,
                duration: 400,
                ease: 'Linear',
                onComplete: function () {
                  child.setTexture('Tred'); 
                }
              },
              {
                scaleX: 1,
                duration: 400,
                ease: 'Linear',
                onComplete: function () {
                  //child.setTexture('card');
                }
              }
              
            ]
          });
        })
    });
    const line = new Phaser.Geom.Line(1000, 600, 1050, 650);
    Phaser.Actions.PlaceOnLine(cardGroup.getChildren(), line);*/




    this.boardHitAreas.push(new Phaser.Geom.Rectangle(0, 0, 600 * this.board.scaleX, 650 * this.board.scaleY));
    this.boardHitAreas.push(new Phaser.Geom.Rectangle(0, 0, 420 * this.board.scaleX, 400 * this.board.scaleY));
    this.boardHitAreas.push(new Phaser.Geom.Rectangle(0, 0, 460 * this.board.scaleX, 550 * this.board.scaleY));
    this.boardHitAreas.push(new Phaser.Geom.Rectangle(0, 0, 280 * this.board.scaleX, 440 * this.board.scaleY));
    this.boardHitAreas.push(new Phaser.Geom.Rectangle(0, 0, 400 * this.board.scaleX, 640 * this.board.scaleY));
    /*this.boardHitAreas.push(Phaser.Geom.Rectangle(0, 0, 100, 100));
    this.boardHitAreas.push(Phaser.Geom.Rectangle(0, 0, 100, 100));*/

    this.hitAreasData.push({items: [], local: [], envahissant: [], stacked: []})
    this.hitAreasData.push({items: [], local: [], envahissant: [], stacked: []})
    this.hitAreasData.push({items: [], local: [], envahissant: [], stacked: []})
    this.hitAreasData.push({items: [], local: [], envahissant: [], stacked: []})
    this.hitAreasData.push({items: [], local: [], envahissant: [], stacked: []})
    /*this.hitAreasData.push({items: [], local: [], envahissant: [], stacked: []})
    this.hitAreasData.push({items: [], local: [], envahissant: [], stacked: []})*/

    console.log(this.boardHitAreas)

    // Add input events for specific hit areas
    this.board.on('pointerdown', function (pointer, localX, localY, event) {
      t.boardHitAreas.forEach((area, index) => {
        console.log("pointer");
        console.log(pointer);
        var p = new Phaser.Geom.Point(pointer.worldX,pointer.worldY);
        if (Phaser.Geom.Rectangle.ContainsPoint(area, p)) {
          console.log('Clicked on Hit Area '+ index);
        }
      })
    });

    this.updateHitAreas();
    if (screenWidth/scale > (screenWidth/scale)/2 + this.param.x + this.param.width/2 + 20){
      this.cameras.main.setBounds(-(screenWidth/scale)/2,-(screenHeight/scale)/2, screenWidth/scale,screenHeight/scale);
    }
    else {
      this.cameras.main.setBounds(-(screenWidth/scale)/2,-(screenHeight/scale)/2, (screenWidth/scale)/2 + this.param.x + this.param.width/2 + 40,screenHeight/scale);
    }
    
    console.log("this scene");
    console.log(this);
    console.log(this.boardHitAreas);
      // const sceneContainer = this.cameras.main;
      // const scaleRatio = 0.5;
      // sceneContainer.setScale(scaleRatio);
    this.showRegle();
    //var t=this;
    this.param.on('pointerdown', function () {
      t.divRegle.x = t.cameras.main.midPoint.x;
      t.divRegle.y = t.cameras.main.midPoint.y;
      t.divRegle.setVisible(true);
    });
  }

  update () {
    //this.updateHitAreas();
    if(this.scoreBuffer > 0){
      this.incrementScore();
      this.scoreBuffer--;
    }
    /*console.log("POINTS");
    console.log(this.cameras.main.midPoint.x);
    console.log(this.cameras.main.midPoint.y);*/
    if (this.iszoom == 0){
      /*this.scoreLabel.x = this.scorex * (scale+0.3) + this.cameras.main.midPoint.x;
      this.scoreLabel.y = this.scorey * (scale+0.3) + this.cameras.main.midPoint.y;*/
      
      /* Bon positionnement
      this.scoreLabel.x = this.cameras.main.worldView.centerX;
      this.scoreLabel.y = this.cameras.main.worldView.bottom -50 ;*/
    }
    else {
      /*this.scoreLabel.x = this.scorex * scale + this.cameras.main.midPoint.x;
      this.scoreLabel.y = this.scorey * scale + this.cameras.main.midPoint.y;*/
      
      /* Bon positionnement
      this.scoreLabel.x = this.cameras.main.worldView.centerX;
      this.scoreLabel.y = this.cameras.main.worldView.bottom -50;*/
    }
    if (this.scoreLabel.text == 0){
      this.scoreLabel.text = 0
    }
  }

  selectCard(card){
    console.log(card)
  }

  incrementScore(){
    //Increase the score by one and update the total score label text
    this.scoreTotal += 1;
    /*console.log("this.score");
    console.log(this);*/
    /*console.log(this.scoreLabel.text);
    console.log(this.scoreLabel);*/
    this.scoreLabel.text = this.scoreTotal;
  }

  createScoreAnimation(x,y,message,scoreLocal){
    var t = this;
    var scoreFont = '80px "Grobold"';
    this.scoreAnimation = this.add.text(x, y, message, {font:scoreFont, fill: "#DAB71C", align:"center",boundsAlignH: "center", boundsAlignV: "middle"});
    this.scoreAnimation.setOrigin(0.5);
    this.scoreTween = this.tweens.add({
      targets: this.scoreAnimation,
      /*x: this.cameras.main.worldView.centerX,
      y: this.cameras.main.worldView.bottom -50,*/
      x: this.scorePosition.x,
      y: this.scorePosition.y,
      duration: 800, 
      ease: 'Expo.easeInOut',
      onComplete: function(scene){
        /*console.log("comparaison");
        console.log(scene);
        console.log(t.scoreLabelTween);*/
        t.scoreAnimation.destroy();
        t.scoreLabelTween.restart();
        /*console.log(t.scoreBuffer);
        console.log(scoreLocal);*/
        t.scoreBuffer += scoreLocal;
        //console.log(t.scoreBuffer);
      }
    });
  }

  updateHitAreas() {
    // Get the world coordinates of the image's corners
    var topLeft = this.board.getTopLeft();
    var topRight = this.board.getTopRight();
    var center = this.board.getCenter();
    var bottomLeft = this.board.getBottomLeft();
    var bottomRight = this.board.getBottomRight();
  

    /*this.boardHitAreas[0] = new Phaser.Geom.Rectangle(0, 0, 100, 100);
    this.boardHitAreas[1] = new Phaser.Geom.Rectangle(0, 0, 100, 100);
    this.boardHitAreas[2] = new Phaser.Geom.Rectangle(0, 0, 100, 100);*/
    /*this.boardHitAreas[3] = new Phaser.Geom.Rectangle(0, 0, 100, 100);
    this.boardHitAreas[4] = new Phaser.Geom.Rectangle(0, 0, 100, 100);*/

    console.log("this.board.scaleY");
    console.log(this.board.scaleY);
    console.log(this.board.scaleX);
    this.boardHitAreas[0].x = center.x - (730 * this.board.scaleX);
    this.boardHitAreas[0].y = center.y - (850 * this.board.scaleY);
    this.boardHitAreas[1].x = center.x - (65 * this.board.scaleX);
    this.boardHitAreas[1].y = center.y - (710 * this.board.scaleY);
    this.boardHitAreas[2].x = center.x + (380 * this.board.scaleX);
    this.boardHitAreas[2].y = center.y - (620 * this.board.scaleY);
    this.boardHitAreas[3].x = center.x + (40 * this.board.scaleX);
    this.boardHitAreas[3].y = center.y - (265 * this.board.scaleY);
    this.boardHitAreas[4].x = center.x - (20 * this.board.scaleX);
    this.boardHitAreas[4].y = center.y + (190 * this.board.scaleY);

    /*this.boardHitAreas[0].x = topLeft.x;
    this.boardHitAreas[0].y = topLeft.y;
    this.boardHitAreas[1].x = topRight.x - this.boardHitAreas[1].width;
    this.boardHitAreas[1].y = topRight.y;
    this.boardHitAreas[2].x = center.x - this.boardHitAreas[2].width/2;
    this.boardHitAreas[2].y = center.y - this.boardHitAreas[2].height/2;*/
    /*this.boardHitAreas[3].x = bottomLeft.x;
    this.boardHitAreas[3].y = bottomLeft.y  - this.boardHitAreas[3].height;
    this.boardHitAreas[4].x = bottomRight.x - this.boardHitAreas[4].width;
    this.boardHitAreas[4].y = bottomRight.y - this.boardHitAreas[4].height;*/
  


    //debug only
    //if(!this.debugGraphics) 
    //ZONE LIGNES ROUGES
    /*this.debugGraphics = this.add.graphics();

    this.debugGraphics.clear();
    this.debugGraphics.lineStyle(2, 0xFF0000);
    this.debugGraphics.strokeRect(this.boardHitAreas[0].x, this.boardHitAreas[0].y, this.boardHitAreas[0].width, this.boardHitAreas[0].height);
    this.debugGraphics.strokeRect(this.boardHitAreas[1].x, this.boardHitAreas[1].y, this.boardHitAreas[1].width, this.boardHitAreas[1].height);
    this.debugGraphics.strokeRect(this.boardHitAreas[2].x, this.boardHitAreas[2].y, this.boardHitAreas[2].width, this.boardHitAreas[2].height);
    this.debugGraphics.strokeRect(this.boardHitAreas[3].x, this.boardHitAreas[3].y, this.boardHitAreas[3].width, this.boardHitAreas[3].height);
    this.debugGraphics.strokeRect(this.boardHitAreas[4].x, this.boardHitAreas[4].y, this.boardHitAreas[4].width, this.boardHitAreas[4].height);*/

    //this.debugGraphics.strokeRect(this.score.x, this.score.y, this.score.width, this.score.height);
  }

  getRelativePositionToCanvas(gameObject, camera) {
    console.log("obj et cam");
    console.log(gameObject);
    console.log(camera);
    return {
      x: (gameObject.x + camera.midPoint.x),
      y: (gameObject.y + camera.midPoint.y)
    }
  }

  showRegle(){
    this.divRegle = this.add.container(0, 0).setSize(screenWidth/scale, screenHeight/scale).setInteractive({
      useHandCursor: true
    });
    this.divRegle.setVisible(false);
    const divregle = document.createElement('div');
    divregle.style = 'width:'+screenWidth/scale+'px;height:'+screenHeight/scale+'px;';
    divregle.innerHTML = "<div id='containerregle' style='background-color: rgba(0, 0, 0, 0.7);width:"+screenWidth/scale+"px;height:"+screenHeight/scale+"px;display:flex;justify-content:center;align-items:center;'><div style='width:930px;height:691px;background-repeat:no-repeat;background-position: center;background-size: contain;background-image: url(\""+regle+"\");color:#2D453D; font: 50px \"Jumbo\";letter-spacing: 10px;font-weight: bold;text-align:center;border-radius:20px'><div style='height: inherit;display: flex;align-items: center;flex-direction: column;justify-content: center;margin: 0 40px;margin-top: 20px;position:relative;'><div id='Regle' style='width:80%;'></div><img id='croixregle' style='position: absolute;right: -60px;top: 0;cursor:pointer;' src='"+croix+"'></div></div></div>";
    var elementregle = this.add.dom(0, 0, divregle);
    /*elementregle.setInteractive({
      useHandCursor: true
    });*/
    this.divRegle.add(elementregle);
    /*console.log("SETINTERACTIVE");
    console.log(elementregle);
    console.log(this.divRegle);*/
    //this.divRegle.setInteractive(new Phaser.Geom.Rectangle(-(screenWidth/scale)/2,-(screenHeight/scale)/2,(screenWidth/scale)/2,(screenHeight/scale)/2), Phaser.Geom.Rectangle.Contains);
    var div = "<div style='height:480px;overflow-y:scroll;color:white;font-family:Inter';align-items: center;>";
    //div += "<div style='display:flex;background-color:#59786E;align-items: center;border-radius: 20px;padding: 15px 30px;margin-bottom: 20px;'>"
    //div += "<div style='margin-right:20px;font-family:Grobold;text-align: center;color: #2D453D;font-size: 40px;padding-top: 10px;'>"+place+"</div>"
    div += "<div style='font-family:Inter;width:100%;text-align:left;font-size: 25px;letter-spacing: 1px;width: 100%;'>";
    div += "<p style='margin-top:0;'>Dans un premier temps, vous devrez placer 5 espèces locales tirées au sort dans les régions où elles sont présentes. Si elles sont bien présentes dans la région choisie, les espèces se fixeront automatiquement sur le barycentre de cette région, pour des questions de place sur le plateau virtuel. Inutile donc de disposer les espèces marines dans la mer et les terrestres sur la terre ferme. Bien placer vos pions du premier coup vous rapportera 5 points par espèce, soit 25 points au total. Attention, certaines espèces locales ont une répartition restreinte, et ne sont pas présentes dans toutes les régions... A chaque erreur, 1 point sera retiré du total : se tromper 5 fois de localisation pour une espèce vous rapportera donc 0 point !</p>"
    div += "<p>Tant que le pion ne se fixe pas (il réduit alors de taille et n’est plus modifiable), il vous faudra modifier la place de chaque espèce, jusqu’à obtenir 5 localisations exactes. Ce dispositif est d’ailleurs valable pour tous vos futurs placements de pions : un pion qui reste déplaçable n’est tout simplement pas placé au bon endroit sur le plateau virtuel.</p>";
    div += "<p>Une fois les 5 espèces locales affectées à une région, le plateau est alors fixé. Comme dans un jeu IRL, il faut à présent piocher. 23 jetons seront tirés aléatoirement, à vous d’adapter votre stratégie de jeu aux jetons tirés : </p>"
    div += "<p style='margin-top:0;'> -	Jeton « EEE » (cerclé de rouge) : doit être placé sur le jeton espèce locale (cerclé de vert) correspondant. Attention : placer 2 jetons EEE sur une espèce locale revient à l’éliminer ! Le jeton espèce locale devient alors transparent... RIP ! seul reste visible le jeton EEE, car l’espèce locale a été éliminée.</p>"
    div += "<p style='margin-top:0;'> -	Jeton « Action » (cerclé de bleu) : annule le jeton EEE placé sur une espèce locale. Sans effet une fois le jeton « espèce locale » devenu transparent, malheureusement... A part rapporter des points pour avoir correctement associé action et EEE correspondante. Et sans autre effet non plus si l’espèce locale n’est pas affectée par un jeton EEE !</p>";
    div += "<p style='margin-top:0;'> -	Jeton « Quiz » : placé sur un jeton EEE, il permet de l’annuler si la bonne réponse est donnée, et rapporte en plus 3 points ! Placé ailleurs, vous cumulerez simplement les points apportés par une bonne réponse... </p>";
    div += "<p style='margin-top:0;'> -	Jeton « Catastrophe » : placé sur un jeton EEE, il double son effet et rendra l’espèce locale concernée transparente... RIP ! Si aucun jeton EEE n’est présent sur le plateau, le jeton Catastrophe sera sans effet et pourra être placé n’importe où. Ouf !</p>";
    div += "<p>Maximisez votre score en utilisant vos connaissances sur les espèces et les moyens de lutte contre les EEE !</p>";
    div += "<p>Un décompte final des points obtenus est effectué une fois la pioche vide, avec 3 points ajoutés pour chaque espèce locale que vous aurez sauvée des EEE. Si les 5 espèces sont préservées sans EEE dans leur zone c’est gagné, s’il n’y a plus d’espèces locales sur le plateau c’est perdu. Vous pourrez alors choisir d’enregistrer votre score dans le Classement du jeu, pour challenger d’autres équipes en ligne.</p>";
    div += "<p>Qui sauvera le plus d’espèces locales et obtiendra le meilleur score ?</p>";
    div += "</div>";
    //div += "<div style='font-family:Grobold;padding-top: 10px;color: #DAB71C;font-size: 40px;'>"+response.classement[i].score+"</div>"
    //div += "</div>";
    div += "</div>"
    document.getElementById('Regle').innerHTML = div;
    var t = this;
    document.getElementById('croixregle').onclick = function(){
      t.divRegle.setVisible(false);
    }
    /*document.getElementById('containerregle').onclick = function(){
      console.log("DANS INTERACTIVE");
    }*/
    //this.divReglecontainer.setVisible(true);
}
  
}
